export default __webpack_public_path__ + "static/media/burgerMenuDark.e97c3323.svg";